import { Ability } from 'ember-can';
import { get } from '@ember/object';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import _intersection from 'lodash/intersection';

import { GLOBAL_ADMIN, LOCATION_ADMIN } from 'garaje/utils/roles';

const ALLOWED_ROLES = [GLOBAL_ADMIN, LOCATION_ADMIN];

export default class VisualComplianceAbility extends Ability {
  @service currentAdmin;
  @service state;

  get canReview() {
    const { currentLocation, vrSubscription } = this.state;
    const config = currentLocation?.visualComplianceConfiguration;
    const contactIds = (config && get(config, 'contactIds')) || [];
    const { roleNames } = this.currentAdmin;

    const hasSubscription = vrSubscription?.canAccessVisualCompliance;
    const hasRole = isPresent(_intersection(ALLOWED_ROLES, roleNames));
    const isContact = contactIds.includes(parseInt(this.currentAdmin.id, 10));

    return hasSubscription && (hasRole || isContact);
  }
}
